import { Component, Input, Output, EventEmitter, inject, computed, signal, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { AuthService } from '../auth/auth.service';
import { NAV_GROUPS, NavGroup, NavChild, findActiveGroup } from './nav-config';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, AvatarModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input() mobileOpen = false;
  @Input() collapsed = false;
  @Output() closeMobile = new EventEmitter<void>();
  @Output() toggleCollapse = new EventEmitter<void>();

  auth = inject(AuthService);
  private router = inject(Router);
  private routerSub!: Subscription;

  currentUrl = signal(this.router.url);

  activeGroup = computed<NavGroup | null>(() => {
    return findActiveGroup(this.currentUrl());
  });

  visibleChildren = computed<NavChild[]>(() => {
    const group = this.activeGroup();
    if (!group) return [];
    return group.children.filter(
      child => !child.module || this.auth.hasModule(child.module)
    );
  });

  get userInitials(): string {
    const user = this.auth.user();
    if (!user) return '?';
    const first = user.user_firstname?.[0] || user.username[0] || '';
    const last = user.user_lastname?.[0] || '';
    return (first + last).toUpperCase();
  }

  ngOnInit(): void {
    this.routerSub = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(e => {
      this.currentUrl.set(e.urlAfterRedirects);
    });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  isActive(route: string): boolean {
    return this.router.url.startsWith(route);
  }

  getFillSettings(): string {
    return '"FILL" 1';
  }

  onNavClick(route: string): void {
    this.closeMobile.emit();
  }
}
